import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e87fa930&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=e87fa930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87fa930",
  null
  
)

export default component.exports